import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@/components/Button';
import { PageHeading } from '@/components/Layout/Parts';
import Text from '@/components/Text';
import { api } from '@/utils/api';

const Frame = styled.iframe`
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 100%;
  min-height: 660px;
  flex: 1;
`;

const StyledPageHeading = styled(PageHeading)`
  text-transform: capitalize;
  margin: 0;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 30px;
`;

const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 30px;
`;

const VibeBone = () => {
  const { data } = useQuery({
    queryKey: ['vibebone_nav_items'],
    queryFn: () =>
      api.get<never, Array<{ name: string; link: string }>>(
        '/v1/vibecode-nav-items',
      ),
    staleTime: Infinity,
  });

  const { slug } = useParams();

  const tool = data?.[parseInt(slug ?? '0')];

  return (
    <Wrap>
      <HeadingRow>
        <div>
          <Text $type="caption" $color="gray">
            {tool?.name ?? 'Loading...'}
          </Text>
          <StyledPageHeading>VibeBone</StyledPageHeading>
        </div>
        <Button
          as="a"
          href={tool?.link ?? `https://vibebone.boredpanda.com`}
          target="_blank"
        >
          Open full page
        </Button>
      </HeadingRow>
      {tool?.link && <Frame src={tool.link} key={slug ?? '0'} />}
    </Wrap>
  );
};

export default VibeBone;
